
import { getRandomWarmTip } from "../utils/getRandomWarmTip";
import type { DailySummaryResult, UserRealtimeSummary, PendingItem, SummaryCounts } from "./dailySummaryService";

// Internal Type representing a Todo document
export interface TodoItem {
  id: string;
  module: string;
  title: string;
  docNo?: string;
  assigneeName?: string;
  currentOwnerName?: string;
  todoStatus: string; // OPEN / CLOSED
  updatedAt?: any;
}

function createEmptyUser(key: "kevin" | "lisa" | "irene", name: string): UserRealtimeSummary {
  return {
    userKey: key,
    displayName: name,
    counts: { contracts: 0, seals: 0, others: 0 },
    dateLabel: new Date().toLocaleDateString(),
    agenda: ["(依行事曆動態載入)"], // Placeholder
    dueSoon: { today: [], within30: [], within60: [] }, // Placeholder
    pendingList: {
      contracts: [], seals: [], cases: [], templates: [], governance: [], others: []
    },
    encouragement: getRandomWarmTip()
  };
}

// Logic to group flat todos into the Dashboard's 3-User Structure
export function computeDashboardSummary(todos: TodoItem[]): DailySummaryResult {
  const users: UserRealtimeSummary[] = [
    createEmptyUser("kevin", "Kevin (法務部)"),
    createEmptyUser("lisa", "Lisa (主管)"),
    createEmptyUser("irene", "Irene (主管)")
  ];

  todos.forEach(todo => {
    // 1. Determine Target User
    // Priority: currentOwnerName > assigneeName > Default(Kevin)
    const owner = (todo.currentOwnerName || todo.assigneeName || "").toLowerCase();
    
    let targetUserKey = "kevin"; // Default
    if (owner.includes("lisa")) targetUserKey = "lisa";
    else if (owner.includes("irene")) targetUserKey = "irene";
    else if (owner.includes("legal") || owner.includes("法務") || owner.includes("kc")) targetUserKey = "kevin";

    const targetUser = users.find(u => u.userKey === targetUserKey) || users[0];

    // 2. Map Item to Dashboard Format
    const item: PendingItem = {
      id: todo.docNo || todo.id,
      title: todo.title || "(無標題)",
      module: "other"
    };

    // 3. Categorize by Module
    const mod = (todo.module || "").toLowerCase();
    
    if (mod.includes("contract") || mod.includes("review")) {
       item.module = "contract";
       targetUser.pendingList.contracts.push(item);
       targetUser.counts.contracts++;
    } else if (mod.includes("seal") || mod.includes("stamp")) {
       item.module = "seal";
       targetUser.pendingList.seals.push(item);
       targetUser.counts.seals++;
    } else if (mod.includes("case") || mod.includes("dispute") || mod.includes("legal")) {
       item.module = "case";
       targetUser.pendingList.cases.push(item);
       targetUser.counts.others++;
    } else if (mod.includes("gov") || mod.includes("compliance")) {
       item.module = "governance";
       targetUser.pendingList.governance.push(item);
       targetUser.counts.others++;
    } else {
       targetUser.pendingList.others.push(item);
       targetUser.counts.others++;
    }
  });

  return {
    generatedAt: new Date().toISOString(),
    users: users,
    emailStatus: { status: 'n/a', info: 'Real-time View' }
  };
}
